import { Type } from 'class-transformer';

import { MagicStructureMembership } from './magic-structure-membership.model';
//import { MagicStructureTrigger } from './magic-structure-trigger.model';
import { MagicStructureTriggerTypeEnum } from '../../enums/magic-structure-trigger-type.enum';
import { IViewModel } from '../../interfaces/view-model.interface';
import { ICloneAndCopy } from '../../interfaces/clone-and-copy';

export class MagicStructureDefinition implements IViewModel, ICloneAndCopy {
    // Define primitive properties.
    // Key.
    public id: number = 0;
    public getId(): number {
        return (this.id);
    }

    public name: string;
    public description: string;

    public useStandardStructureName: boolean = false;
    public standardStructureName: string;

    public createOneStructurePerMember: boolean = false;

    // Note:  property 'copiesFolderName' contains the suggested name of
    //        the root folder within which all magic structures are copied.
    public copiesFolderName: string;

    // Define contained entities.
    @Type(() => MagicStructureMembership)
    public memberships: MagicStructureMembership[];

    //public triggers: MagicStructureTrigger[];
    //@Type(() => MagicStructureTrigger)
    //public trigger: MagicStructureTrigger;
    public triggerType: string = MagicStructureTriggerTypeEnum.NOW;
    public scheduledTriggerDateTime: Date;
    public scheduledTriggerHoursOffset: string;
    public scheduledEventId: number;

    // Implement ICloneAndCopy methods.
    public clone(): ICloneAndCopy {
        let clone: MagicStructureDefinition = new MagicStructureDefinition();
        clone.copy(this);

        return clone;
    }

    public copy(objectToCopy: ICloneAndCopy): void {
        let structureToCopy = <MagicStructureDefinition>objectToCopy;

        this.id = structureToCopy.id;

        this.name = structureToCopy.name;
        this.description = structureToCopy.description;

        this.useStandardStructureName = structureToCopy.useStandardStructureName;
        this.standardStructureName = structureToCopy.standardStructureName;

        this.createOneStructurePerMember = structureToCopy.createOneStructurePerMember;

        this.copiesFolderName = structureToCopy.copiesFolderName;

        this.memberships = [];
        if (structureToCopy.memberships != null) {
            for (let iMembership: number = 0; iMembership < structureToCopy.memberships.length; iMembership++) {
                let membership: MagicStructureMembership = structureToCopy.memberships[iMembership];
                let membershipClone: MagicStructureMembership = <MagicStructureMembership>membership.clone();

                this.memberships.push(membershipClone);
            }
        }

        this.triggerType = structureToCopy.triggerType;
        this.scheduledTriggerDateTime = structureToCopy.scheduledTriggerDateTime;
        this.scheduledTriggerHoursOffset = structureToCopy.scheduledTriggerHoursOffset;
        this.scheduledEventId = structureToCopy.scheduledEventId;
    }
}
